var _path, _path2, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C13.9711 0 18 4.02891 18 9C18 13.9711 13.9711 18 9 18C4.02891 18 0 13.9711 0 9C0 4.02891 4.02891 0 9 0Z",
    fill: "url(#paint0_radial_3488_416)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71973 6.95041C7.53027 5.18206 10.4693 5.18206 12.2799 6.95041L12.4979 7.16487C12.5893 7.25276 12.5893 7.3969 12.4979 7.48479L11.7525 8.21252C11.7068 8.25823 11.633 8.25823 11.5873 8.21252L11.2885 7.92073C10.0229 6.68674 7.97676 6.68674 6.71113 7.92073L6.39121 8.23362C6.34551 8.27932 6.27168 8.27932 6.22598 8.23362L5.48066 7.50588C5.38926 7.41799 5.38926 7.27385 5.48066 7.18596L5.71973 6.95041ZM13.8232 8.4551L14.4877 9.10198C14.5791 9.18987 14.5791 9.33401 14.4877 9.4219L11.4959 12.3434C11.4045 12.4313 11.2568 12.4313 11.1689 12.3434L9.04551 10.2692C9.02441 10.2481 8.98574 10.2481 8.96465 10.2692L6.84121 12.3434C6.74981 12.4313 6.60215 12.4313 6.51426 12.3434L3.51191 9.4219C3.42051 9.33401 3.42051 9.18987 3.51191 9.10198L4.17637 8.4551C4.26777 8.36721 4.41543 8.36721 4.50332 8.4551L6.62676 10.5293C6.64785 10.5504 6.68652 10.5504 6.70762 10.5293L8.83106 8.4551C8.92246 8.36721 9.07012 8.36721 9.15801 8.4551L11.2814 10.5293C11.3025 10.5504 11.3412 10.5504 11.3623 10.5293L13.4857 8.4551C13.5842 8.36721 13.7318 8.36721 13.8232 8.4551Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3488_416",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.57899e-05 9.00028) scale(18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.35625441169365a5ce4fc2f8501ad1b1.svg";
export { ForwardRef as ReactComponent };